export enum GPStatusType {
  Opening,
  InProgress,
  Finished,
  Completed,
}
